module.exports = __webpack_public_path__ + "static/media/Legends.f4dc9b67.svg";